import { userService } from "../api/user-auth";
import moment from "moment";

const state = {
  schedule_start_date: null,
  selected_week: 0,
  selected_week_index: 0,
  selected_week_start: "",
  selected_week_end: "",
  schedule_group: null,
  schedules: [],
  schedule_group_weeks: [],
  combined_weeks_count: Number(0),
  available_jobs: [],
  next_schedule_round_tmp_id: -2,
  schedule_rounds: {},
  changes: [],
};

const getters = {
  weeks: state => {
    return state.schedule_group_weeks;
  },
  available_jobs: state => {
    return state.available_jobs;
  },
  num_weeks: state => {
    if (state.schedule == null) {
      return 0;
    }
    return state.schedule.duration;
  },
  num_days_in_week: state => {
    if (state.schedule == null) {
      return 0;
    }
    return state.schedule.days;
  },
  getJobsForSite: state => id => {
    var result = [];
    state.schedule_group_weeks.forEach(schedule => {
      schedule.forEach(week => {
        week.days.forEach(day => {
          day.rounds
            .filter(function(value) {
              var jobs = value.round.jobs.filter(function(value2) {
                var plants = value2.plants.filter(function(value3) {
                  return value3.site_id == id;
                });
                return plants.length > 0;
              });
              return jobs.length > 0;
            })
            .forEach(round => {
              result.push(round);
            });
        });
      });
    });
    return result;
  },
  getRoundsForJob: state => id => {
    var result = [];
    state.schedule_group_weeks.forEach(schedule => {
      schedule.forEach(week => {
        week.days.forEach(day => {
          day.rounds
            .filter(function(value) {
              var jobs = value.round.jobs.filter(function(value2) {
                return value2.id == id;
              });
              return jobs.length > 0;
            })
            .forEach(round => {
              result.push(round);
            });
        });
      });
    });
    return result;
  },
};

const actions = {
  select_next_week({ commit }) {
    commit("select_next_week");
  },
  select_previous_week({ commit }) {
    commit("select_previous_week");
  },
  nextTmpScheduleRoundId({ commit }) {
    return new Promise(resolve => {
      setTimeout(() => {
        commit("next_tmp_schedule_round_id");
        resolve();
      }, 1000);
    });
  },
  loadSchedule({ commit }, schedule) {
    commit("loadSchedule", schedule);
  },
  loadAvailableJobs({ commit }, avail_customers) {
    commit("loadAvailableJobs", avail_customers);
  },
  getSchedule({ dispatch, commit }) {
    userService.getJson("schedule/current").then(
      response => {
        if (response.ok) {
          commit("loadSchedule", response.data);
          if ("id" in response.data) {
            dispatch("schedule/getAvailableJobs", response.data.id, {
              root: true,
            });
          }
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  updateAvailableJobsOfCustomer({ commit }, customer) {
    commit("updateAvailableJobsOfCustomer", customer);
  },
  getAvailableJobs({ dispatch, commit }, schedule_id) {
    userService.getJson("schedule/" + schedule_id + "/job/list").then(
      response => {
        if (response.ok) {
          commit("loadAvailableJobs", response.data);
        } else {
          commit("clear_avail_jobs");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear_avail_jobs");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  addAvailableJob({ commit }, job) {
    commit("addAvailableJob", job);
  },
  saveSchedule({ dispatch, commit, state }) {
    var data = {
      group: state.schedule_group,
      schedules: state.schedules,
      weeks: state.schedule_group_weeks,
    };
    userService.post("schedule/" + state.schedule_group.id, data).then(
      response => {
        if (response.ok) {
          commit("loadSchedule", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  updateScheduleDetails({ dispatch, commit, state }, schedule) {
    var schedule_copy = {};
    Object.assign(schedule_copy, state.schedule);
    schedule_copy.name = schedule.name;
    schedule_copy.duration = schedule.duration;
    schedule_copy.days = schedule.days;
    schedule_copy.date = schedule.date;
    userService.post("schedule/" + schedule_copy.id, schedule_copy).then(
      response => {
        if (response.ok) {
          commit("loadSchedule", response.data);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  moveScheduleRoundFrom(
    { commit },
    { schedule_index, schedule_round, from_week_index, from_day_index },
  ) {
    commit("moveScheduleRound", {
      schedule_index: schedule_index,
      schedule_round: schedule_round,
      from_week_index: from_week_index,
      from_day_index: from_day_index,
    });
  },
  moveScheduleRoundTo(
    { commit },
    { schedule_index, schedule_round, to_week_index, to_day_index },
  ) {
    var from_week_index = schedule_round.week_index;
    var from_day_index = schedule_round.day_index;
    schedule_round.week_index = to_week_index;
    schedule_round.day_index = to_day_index;
    commit("moveScheduleRound", {
      schedule_index: schedule_index,
      schedule_round: schedule_round,
      from_week_index: from_week_index,
      from_day_index: from_day_index,
    });
  },
  copyWeekTo({ commit }, { schedule_index, from_week, to_week }) {
    commit("copyWeekTo", {
      schedule_index: schedule_index,
      from_week: from_week,
      to_week: to_week,
    });
  },
  copyWeekToSchedule(
    { commit },
    { from_schedule_index, to_schedule_index, from_week, to_week },
  ) {
    commit("copyWeekTo", {
      from_schedule_index: from_schedule_index,
      to_schedule_index: to_schedule_index,
      from_week: from_week,
      to_week: to_week,
    });
  },
  set_schedule_start_date({ commit }, date) {
    commit("set_schedule_start_date", date);
  },
  create_round_change({ commit }, { round, from, to }) {
    commit("create_round_change", { round: round, from: from, to: to });
  },
};

const mutations = {
  updateWeekIndexAndDates(state){
    state.selected_week_index =
      ((state.selected_week % state.combined_weeks_count) +
        state.combined_weeks_count) %
      state.combined_weeks_count;
    state.selected_week_start = moment(state.schedule_start_date)
      .add(state.selected_week * 7, "days")
      .format("DD/MM");
    state.selected_week_end = moment(state.schedule_start_date)
      .add(state.selected_week * 7 + 6, "days")
      .format("DD/MM");
  },
  loadSchedule(state, schedule_group) {
    state.schedule_group = schedule_group;
    state.changes = schedule_group.changes;
    state.schedule_start_date = new Date(schedule_group.start);
    state.schedules = schedule_group.schedules;
    state.schedule_group_weeks = schedule_group.weeks;
    state.combined_weeks_count = Number(schedule_group.duration);
    state.schedule_rounds = schedule_group.schedule_rounds;
    state.selected_week = Math.round(
      (moment() - moment(state.schedule_start_date)) /
        (7 * 24 * 60 * 60 * 1000),
    );
    this.commit("schedule/updateWeekIndexAndDates", state);
  },
  loadAvailableJobs(state, available_jobs) {
    available_jobs.sort(function(a, b) {
      if (a.description.toLowerCase() == b.description.toLowerCase()) return 0;
      return a.description.toLowerCase() > b.description.toLowerCase() ? 1 : -1;
    });
    state.available_jobs = available_jobs;
  },
  updateAvailableJobsOfCustomer(state, customer) {
    if (!customer.active) {
      //todo reactivate jobs
      var updated_list = state.available_jobs.filter(function(value) {
        return value.customer_id != customer.id;
      });
    }
    state.available_jobs = updated_list;
  },
  addAvailableJob(state, job) {
    state.available_jobs.push(job);
    state.available_jobs.sort(function(a, b) {
      if (a.description.toLowerCase() == b.description.toLowerCase()) return 0;
      return a.description.toLowerCase() > b.description.toLowerCase() ? 1 : -1;
    });
  },
  moveScheduleRound(
    state,
    { schedule_index, schedule_round, from_week_index, from_day_index },
  ) {
    if (from_week_index >= 0 && from_day_index >= 0) {
      var rounds =
        state.schedule_group_weeks[schedule_index][from_week_index].days[
          from_day_index
        ].rounds;
      var updated_rounds = rounds.filter(function(value) {
        return value.id != schedule_round.id;
      });
      state.schedule_group_weeks[schedule_index][from_week_index].days[
        from_day_index
      ].rounds = updated_rounds;
    }
    state.schedule_group_weeks[schedule_index][schedule_round.week_index].days[
      schedule_round.day_index
    ].rounds.push(schedule_round);
  },
  copyWeekTo(state, { schedule_index, from_week, to_week }) {
    if (
      state.schedule_group_weeks[schedule_index].length >= from_week &&
      state.schedule_group_weeks[schedule_index].length >= to_week
    ) {
      var week_to_copy = state.schedule_group_weeks[schedule_index][from_week];
      var week_result = state.schedule_group_weeks[schedule_index][to_week];

      for (let i = 0; i < 7; i++) {
        if (week_to_copy.days.length > i) {
          var from_day = week_to_copy.days[i];

          // should only happen when a 7 day week is changed to 5
          // and a round is left on the weekend
          if (week_result.days.length <= i) {
            var to_day = { week: to_week, day: i, description: "", rounds: [] };
          }
          to_day = week_result.days[i];
          from_day.rounds.forEach(function(round_to_copy) {
            let next_schedule_id = state.next_schedule_round_tmp_id;
            state.next_schedule_round_tmp_id += 1;
            var rd = {
              week_index: to_week,
              active: true,
              personnels: round_to_copy.personnels.slice(),
              round_id: round_to_copy.round_id,
              round: round_to_copy.round,
              day_index: round_to_copy.day_index,
              vehicle_id: round_to_copy.vehicle_id,
              vehicle: round_to_copy.vehicle,
              sequence_order: round_to_copy.sequence_order,
              schedule_id: round_to_copy.schedule_id,
              date: round_to_copy.date,
              id: next_schedule_id,
            };
            to_day.rounds.push(rd);
            state.schedule_rounds.push(rd);
          });
        }
      }
      state.schedule_group_weeks[schedule_index][to_week] = week_result;
    }
  },
  copyWeekToSchedule(
    state,
    { from_schedule_index, to_schedule_index, from_week, to_week },
  ) {
    if (
      state.schedule_group_weeks[from_schedule_index].length >= from_week &&
      state.schedule_group_weeks[to_schedule_index].length >= to_week
    ) {
      var week_to_copy =
        state.schedule_group_weeks[from_schedule_index][from_week];
      var week_result = state.schedule_group_weeks[to_schedule_index][to_week];

      for (let i = 0; i < 7; i++) {
        if (week_to_copy.days.length > i) {
          var from_day = week_to_copy.days[i];

          // should only happen when a 7 day week is changed to 5
          // and a round is left on the weekend
          if (week_result.days.length <= i) {
            var to_day = { week: to_week, day: i, description: "", rounds: [] };
          }
          to_day = week_result.days[i];
          from_day.rounds.forEach(function(round_to_copy) {
            let next_schedule_id = state.next_schedule_round_tmp_id;
            state.next_schedule_round_tmp_id += 1;
            var rd2 = {
              week_index: to_week,
              active: true,
              personnels: round_to_copy.personnels.slice(),
              round_id: round_to_copy.round_id,
              round: round_to_copy.round,
              day_index: round_to_copy.day_index,
              vehicle_id: round_to_copy.vehicle_id,
              vehicle: round_to_copy.vehicle,
              sequence_order: round_to_copy.sequence_order,
              schedule_id: round_to_copy.schedule_id,
              date: round_to_copy.date,
              id: next_schedule_id,
            };
            to_day.rounds.push(rd2);
          });
        }
      }
      state.schedule_group_weeks[to_schedule_index][to_week] = week_result;
    }
  },
  set_schedule_start_date(state, date) {
    state.schedule_start_date = date;
  },
  clear(state) {
    state.schedule = null;
    state.available_jobs = [];
    state.schedules = [];
    state.num_weeks = 0;
    state.num_days_in_week = 0;
    state.selected_week = 0;
    state.selected_week_index = 0;
    state.selected_week_start = "";
    state.selected_week_end = "";
    state.changes = [];
    state.schedule_rounds = {};
  },
  clear_avail_jobs(state) {
    state.available_jobs = [];
  },
  next_tmp_schedule_round_id(state) {
    state.next_schedule_round_tmp_id -= 1;
  },
  select_next_week(state) {
    state.selected_week = state.selected_week + 1;
    this.commit("schedule/updateWeekIndexAndDates", state);
  },
  select_previous_week(state) {
    state.selected_week = state.selected_week - 1;
    this.commit("schedule/updateWeekIndexAndDates", state);
  },
  create_round_change(state, { round, from, to }) {
    var change = {
      id: -1,
      schedule_round_id: round.id,
      from_date: from,
      to_date: to,
      active: true,
    };
    round.changes.push(change);
    state.changes.push(change);
  },
};

export const schedule = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
